<mobile-page-content [fullPageWidth]="true" class="page-content">
    <app-mobile-header header [hasSideMenu]="true"></app-mobile-header>

    <app-mobile-side-menu right-menu></app-mobile-side-menu>

<!--<side-menu left-menu>
        <test-side-menu [tests]="testsLeftMenu" [organization]="organization" [athlete]="athlete"></test-side-menu>
    </side-menu>
    -->

    <app-mobile-test-side-menu *ngIf="testsLeftMenu" [tests]="testsLeftMenu" [organization]="organization" [athleteUser]="athleteUser"></app-mobile-test-side-menu>

    <module-content *ngIf="!is401 && !is404">
        <div class="horizontal-scroll-wrapper">
            <div class="graph-min-600">
                <test-multi-line-borg-chart
                        [showTooltip]="true"
                        title=""
                        [data]="data?.series.borg"
                        [graphClass]="graphClass"
                ></test-multi-line-borg-chart>
            </div>
        </div>
    </module-content>
</mobile-page-content>
